export const FILTER_QUERY = {
  LINKEDIN_URL: 'talent.sanitizedLinkedinUrl',
  RUN_ID: 'runId',
  RUN_MATCH_FLOW_ID: 'metadata.matchFlowRunId',
  RUN_STATUS: 'status',
};
